import React from 'react';
import FlipMove from 'react-flip-move';

import RealTimeDepartures from "./RealTimeDepartures";

const DepartureList = ({stop, time, routes, departures}) => {
    const singleDepartureList = Object.values(routes).map(route => {
        // Find the next departure for that route
        const departure = departures.find(dep => dep.route === route.route_id && dep.departure.isAfter());

        return departure || {route: route.route_id, departure: null}
    });

    singleDepartureList.sort((a, b) =>
        (a.departure === null) - (b.departure === null) ||
        +(a.departure > b.departure) ||
        -(a.departure < b.departure)
    );

    return (
        <FlipMove enterAnimation="fade" duration={500} easing="ease-out">
            {singleDepartureList.map(dep => (
                <RealTimeDepartures
                    key={`${dep.route}/${stop.stop_id}`}
                    time={time}
                    stop={stop}
                    route={routes[dep.route]}
                    departure={dep}
                />
            ))}
        </FlipMove>
    );
};

export default DepartureList;



// WEBPACK FOOTER //
// ./src/components/DepartureList.js